import React from 'react';

const steps = [
  {
    icon: '🧾',
    title: 'Snap Your Receipt',
    desc: 'Upload a receipt from any store — supermarket, corner shop, or market.'
  },
  {
    icon: '🔍',
    title: 'We Verify the Prices',
    desc: 'Real purchase data, extracted and verified. No guesswork, no advertised prices.'
  },
  {
    icon: '📊',
    title: 'Compare Across Stores',
    desc: 'See what people actually paid at every store near you.'
  },
  {
    icon: '💰',
    title: 'Everyone Saves',
    desc: 'More receipts means better data. The community grows, everyone wins.'
  }
];

export default function HowItWorks() {
  return (
    <section className="max-w-5xl mx-auto px-4 py-12">
      <h2 className="text-2xl font-bold mb-3 text-gray-800 text-center">How It Works</h2>
      <p className="text-gray-500 text-center mb-8 max-w-xl mx-auto">Stop guessing. Start comparing. Upload a receipt and help your community find the cheapest store for their weekly shop.</p>
      <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6">
        {steps.map((step, i) => (
          <div key={step.title} className="bg-white rounded-xl shadow p-6 flex flex-col items-center text-center relative">
            <div className="absolute -top-3 -left-3 w-7 h-7 bg-red-800 text-white rounded-full flex items-center justify-center text-sm font-bold">{i + 1}</div>
            <div className="text-4xl mb-4">{step.icon}</div>
            <div className="font-semibold text-lg mb-2">{step.title}</div>
            <div className="text-gray-500 text-sm">{step.desc}</div>
          </div>
        ))}
      </div>
    </section>
  );
} 